export default __webpack_public_path__ + "static/media/placeholder_business03-es-web.53e73c8e.png";